/// <amd-module name="hypo_elements/Partials/ModalFenster/ModalFenster"/>
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define("hypo_elements/Partials/ModalFenster/ModalFenster", ["require", "exports", "hypo_elements/Typescripts/CallbackProvider/CallbackProvider", "bootstrap", "jquery"], function (require, exports, callbackProvider) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.closeModal = exports.getBody = exports.showModal = void 0;
    callbackProvider = __importStar(callbackProvider);
    function loadPage(href) {
        var $deferred = $.Deferred();
        $.get(href, function (xhrHtml) {
            var content = {
                title: "",
                body: "",
            };
            $(xhrHtml).filter(function (indexXhr, elementXhr) {
                if (elementXhr.nodeName === "TITLE") {
                    content.title = $.trim($(elementXhr).text());
                }
                if (elementXhr.className === "modalFenster_text") {
                    content.body = $.trim($(elementXhr).html());
                }
            });
            $deferred.resolve(content);
        }).fail($deferred.reject);
        return $deferred;
    }
    function showModal(href, options) {
        var $deferred = $.Deferred();
        var $modalFenster = $("#modalFensterID");
        var $modalFensterTitle = $modalFenster.find(".modalFenster_title");
        var $modalFensterBody = $modalFenster.find(".modalFenster_body");
        $modalFensterTitle.text("Inhalt wird geladen...");
        $modalFensterBody.text("");
        $modalFenster.modal("show");
        if (options.openCallback && typeof options.openCallback === "function") {
            $modalFenster.on("shown.bs.modal", function () {
                options.openCallback();
            });
        }
        if (options.closeCallback && typeof options.closeCallback === "function") {
            $modalFenster.on("hidden.bs.modal", function () {
                options.closeCallback();
            });
        }
        loadPage(href)
            .then(function (content) {
            if (typeof options !== "undefined" && options.wrapperClass) {
                content.body = "<div class='".concat(options.wrapperClass, "'>").concat(content.body, "</div>");
            }
            $modalFensterTitle.text(content.title);
            $modalFensterBody.html(content.body);
            callbackProvider.register($modalFensterBody);
            $deferred.resolve();
        })
            .fail(function (err) {
            $modalFensterTitle.text("Fehler");
            $modalFensterBody.html("Inhalt konnte nicht geladen werden.");
            $deferred.reject(err);
        });
        return $deferred;
    }
    exports.showModal = showModal;
    function getBody(href) {
        var $deferred = $.Deferred();
        loadPage(href).then(function (content) {
            $deferred.resolve(content.body);
        });
        return $deferred;
    }
    exports.getBody = getBody;
    function closeModal() {
        $("#modalFensterID").modal("hide");
    }
    exports.closeModal = closeModal;
});
